import { render, staticRenderFns } from "./ArticleComments.vue?vue&type=template&id=2512b01d&scoped=true"
import script from "./ArticleComments.vue?vue&type=script&lang=js"
export * from "./ArticleComments.vue?vue&type=script&lang=js"
import style0 from "./ArticleComments.vue?vue&type=style&index=0&id=2512b01d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512b01d",
  null
  
)

export default component.exports